import React, { useEffect, useState, useRef } from "react";
import axiosInstance from "../../ReusableComponents/Axios";
import { Bar } from "react-chartjs-2";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const Lowiseperformance = (props) => {
    const chartRefs = useRef({});
    const [LoWP, SetLoWP] = useState({});
    const [graphImages, setGraphImages] = useState({});

    const GetAllSubjectsData = async () => {
        props.GraphImg({});
        try {
            const requests = props.Subjects?.map((subject) =>
                axiosInstance.get(
                    `/InstitutionAdmin/GetLOWisePerformanceByInstitute?ContestcreationId=${props.CCAT?.contestCreationId}&SubjectName=${subject}&AssessmentType=${props.CCAT?.assessmentType}&InstituteId=${props.SIND}&Grade=${props.Grade}`
                )
            );

            const responses = await Promise.all(requests);

            let finalData = {};

            responses.forEach((res, index) => {
                finalData[props.Subjects[index]] = res.data.map((item) => ({
                    lo: item.lo,
                    percentage: item.percentage,
                }));
            });

            SetLoWP(finalData);

            setTimeout(() => {
                captureAllGraphs();
            }, 1500);

        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        GetAllSubjectsData();
    }, [props.CCAT, props.SelectINID, props.Grade, props?.Subjects]);

    const captureAllGraphs = () => {
        let images = {};

        props.Subjects.forEach((subject) => {
            const chart = chartRefs.current[subject];

            if (chart) {
                images[subject] = chart.toBase64Image();
            }
        });

        setGraphImages(images);
        props.GraphImg(images);
    };

    return (
        <>
            {props.Subjects?.map((subject) => {
                const labels = LoWP?.[subject]?.map((i) => i.lo) || [];
                const values = LoWP?.[subject]?.map((i) => i.percentage) || [];

                const data = {
                    labels: labels.map((l, i) => `${l}`),
                    datasets: [
                        {
                            label: "Performance %",
                            data: values,
                            backgroundColor: values.map((v) =>
                                v <= 40 ? "#FF2A2A" :
                                    v <= 70 ? "#F39C12" :
                                        "#39C560"
                            ),
                        },
                    ],
                };

                const options = {
                    indexAxis: "y",
                    responsive: true,
                    plugins: {
                        legend: { display: false },
                        title: {
                            display: true,
                            text: `Grade_${props.Grade} - ${subject}`,
                            font: {
                                size: 34,
                            },
                        },
                        datalabels: {
                            // anchor: "end",
                            // align: "end",
                            // formatter: (value) => value + "%",
                             formatter: (value) => {
        return value == "0.00" ? "" : `${value}%`;
    },
                             color: () => "#FFFFFF",
                            font: {
                                weight: "bold",
                                size: 20,
                            },
                        },
                    },
                    // anchor: "end",
                    // align: "top",
                    // formatter: (value) => {
                    //     return value;
                    // },
                    // font: {
                    //     weight: "bold",
                    //     size: 24,
                    // },
                    scales: {
                        x: {
                            beginAtZero: true,
                            max: Math.max(...values, 0) + 10,
                            ticks: {
                                font: {
                                    size: 30,
                                },
                            },
                            title: {
                                display: true,
                                text: "Performance %",
                                font: {
                                    size: 34,
                                },
                            },
                        },
                        y: {
                            //   ticks: {
                            //     font: {
                            //         size: 10,
                            //     },
                            // },
                            title: {
                                display: true,
                                text: "Learning Outcomes",
                                font: {
                                    size: 34,
                                },
                            },
                        },
                    },
                };

                return (
                    <div key={subject} style={{

                        // marginBottom: "30px", width: "100%",
                        // height: "450px", 
                    }}>
                        <Bar style={{ display: "none" }} data={data}
                            options={options} plugins={[ChartDataLabels]}
                            ref={(el) => (chartRefs.current[subject] = el)} />
                    </div>
                );
            })}
        </>
    );
};

export default Lowiseperformance;